import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'describeFileExtension'
})
export class DescribeFileExtensionPipe implements PipeTransform {
  transform(value: string[], mode: 'comma-or' | 'dot' | 'input-accept'): string {
    switch (mode) {
      case 'dot': {
        return value.join(' · ');
      }
      case 'comma-or': {
        let concatenatedString: string = '';
        value.forEach((fileExtension, i) => {
          if (i > 0) {
            if (i === value.length - 1) {
              concatenatedString += ' or ';
            } else {
              concatenatedString += ', ';
            }
          }
          concatenatedString += fileExtension;
        });
        return concatenatedString;
      }
      case 'input-accept': {
        return '.' + value.join(', .');
      }
    }
  }
}
